export enum RoutesNoBars {
  autentication = '/autenticacion',
  error = '/error'
}
